import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./pages/all/Navbar";
import Home from "./pages/home";
import Fracht from "./pages/fracht";
import Leerfahrten from "./pages/leerfahrt";
import Pricing from "./pages/pricing";
import Contact from "./pages/contact";
import Jobs from "./pages/jobs";

function App() {
  return (
    <div>
      <main className="min-h-screen bg-gray-50 dark:bg-zinc-900 transition-colors duration-300">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fracht" element={<Fracht />} />
          <Route path="/leerfahrten" element={<Leerfahrten />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
